<template>
  <div class="column-100">
  
    <p class="input-error-message" v-if="error_message">{{error_message}}</p>
    <label>Email*</label>
    <input name="email" v-model="email" type="email"  :placeholder="'Email' + (is_required ? '*' : '')" :class="{'validate-error':error_message}" />

  </div>
</template>

<script>
    import {fields} from '../../mixins/requests/fields'
    import {field_component_mixin} from './field_component_mixin'

    export default {
        name: "email",
        mixins: [fields, field_component_mixin],
        data(){
            return{
                field_name: "email"
            }
        },
        computed: {

        },

    }
</script>

<style scoped>
</style>